import { List as ImmutableList } from 'immutable';
// @ts-expect-error - Missing declaration file for conversations-message-history module
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error - Missing declaration file for conversations-internal-schema module

import { isFromVisitor, isFromBot, isFromAgent
// @ts-expect-error - Missing declaration file for conversations-message-history module
} from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { postPlayEvent, postPauseEvent } from './actions/postPlayButtonClickEvent';
// @ts-expect-error - Missing declaration file for conversations-visitor-ui module

const isBotOrAgentMessage = message => {
  return isFromBot(message) || isFromAgent(message);
};
export const getRecentBotMessagesSinceLastVisitor = (messagesList, currentMessageId) => {
  if (!messagesList) {
    return [];
  }
  const messagesArray = messagesList.toArray();
  const currentMessageIndex = messagesArray.findIndex(msg => getId(msg) === currentMessageId);
  if (currentMessageIndex === -1) {
    return [];
  }
  let lastVisitorIndex = -1;
  for (let i = currentMessageIndex - 1; i >= 0; i--) {
    if (isFromVisitor(messagesArray[i])) {
      lastVisitorIndex = i;
      break;
    }
  }
  const startIndex = lastVisitorIndex + 1;
  const endIndex = currentMessageIndex + 1;
  return messagesArray.slice(startIndex, endIndex).filter(msg => isBotOrAgentMessage(msg));
};
const isLastMessage = positionDescriptors => {
  if (ImmutableList.isList(positionDescriptors)) {
    return positionDescriptors.includes('LAST');
  }
  const descriptors = positionDescriptors;
  if (typeof (descriptors === null || descriptors === void 0 ? void 0 : descriptors.includes) === 'function') {
    return descriptors.includes('LAST');
  }
  if (typeof (descriptors === null || descriptors === void 0 ? void 0 : descriptors.get) === 'function') {
    return Boolean(descriptors.get('LAST'));
  }
  return false;
};
const hasLaterBotOrAgentMessages = (messagesList, currentMessageIndex) => {
  const messagesAfterCurrent = messagesList.slice(currentMessageIndex + 1);
  return messagesAfterCurrent.toArray().some(msg => isBotOrAgentMessage(msg));
};

/**
 * Only show the play button if the latest message is a bot or agent message
 */
export const shouldShowPlayButton = (message, positionDescriptors, messagesList, speechPocActive) => {
  if (!speechPocActive || !isBotOrAgentMessage(message)) {
    return false;
  }
  if (isLastMessage(positionDescriptors)) {
    return true;
  }
  if (!messagesList) {
    return false;
  }
  const currentMessageId = getId(message);
  const currentMessageIndex = messagesList.findIndex(msg => getId(msg) === currentMessageId);
  if (currentMessageIndex === -1) {
    return false;
  }
  return !hasLaterBotOrAgentMessages(messagesList, currentMessageIndex);
};

/**
 * Extract text content from a message, handling various data types
 */
const extractMessageText = message => {
  const text = message.get('text');
  return typeof text === 'string' ? text : '';
};

/**
 * Combine text from multiple messages into a single string
 */
const combineMessageText = messages => {
  return messages.map(extractMessageText).join(' ');
};
export const handlePlayButtonClick = (audioPlaybackStatus, messagesList, messageId) => {
  if (audioPlaybackStatus === 'loading') {
    return;
  }
  if (audioPlaybackStatus === 'playing') {
    postPauseEvent();
    return;
  }
  const recentBotMessages = getRecentBotMessagesSinceLastVisitor(messagesList, messageId);
  const combinedText = combineMessageText(recentBotMessages);
  postPlayEvent(combinedText);
};